<mat-toolbar class="mat-typography footer" color="primary">
  <span i18n="FooterComponentDescription|Footer Component Description@@footerComponent_Description">XD Cloud – XD BackOffice Online</span>
</mat-toolbar>
